import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";

import { objectToFormData } from "../../../../utils";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { currentUserId } from "../../../../utils/constants";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { useUserMutationDialog } from "../hooks/useUserMutationDialog";
import { getActiveDialogContent } from "../utils/userManagementUtils";

function Active({ isActive, id }) {
  const userId = currentUserId();
  const activeDialog = useUserMutationDialog({
    userId: id,
    initialValue: isActive,
    createPayload: (status) => objectToFormData({ active: !status }),
    getNextValue: (status) => !status,
  });
  const dialogContent = useMemo(
    () => getActiveDialogContent(activeDialog.value),
    [activeDialog.value]
  );

  return (
    <>
      {userId !== id && (
        <CustomMenuItem
          onClick={() => {
            userId !== id && activeDialog.openDialog();
          }}
        >
          <PersonOffOutlinedIcon className="user-management-action-icon mr-2"/>
          <p>{activeDialog.value ? "Disable" : "Enable"}</p>
          {activeDialog.isDialogOpen && (
            <FormDialog
              open={activeDialog.isDialogOpen}
              handleClose={activeDialog.closeDialog}
              loading={activeDialog.isSubmitting}
              handleSubmit={activeDialog.submit}
              buttonTxt={dialogContent.buttonText}
              cancelBtn={true}
              title={dialogContent.title}
            >
              <Typography className="align_text_center mb-2 ">
                {dialogContent.message}
              </Typography>
            </FormDialog>
          )}
        </CustomMenuItem>
      )}
    </>
  );
}

export default React.memo(Active);
